import { ref } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { isEqual } from 'lodash-es';
import { useAppLoading } from '@/stores/app/loading';
import { useAppPagination } from '@/stores/app/pagination';
import { useAppRoute } from '@/stores/app/route';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { useFilters } from '@/stores/filters/filters';
import { removeEmptyParams } from '@/stores/filters/helpers';
import { getJobProfileTemplates } from '@/api/jobProfile';

export const useJobProfileTemplates = defineStore('jobProfileTemplates', () => {
  const { setLoading } = useAppLoading();
  const { updatePagination } = useAppPagination();
  const { updateFilters } = useFilters();
  const routeStore = useAppRoute();

  const { searchTerm } = storeToRefs(useFilters());

  const jobProfileTemplates = ref([]);

  const loadJobProfileTemplates = async ({
    routeQuery,
    router,
    page,
    searchTerm: newSearchTerm,
    selectedSubMenuOption: subMenuOption,
  }) => {
    setLoading({ pageLoading: true, listLoading: true });
    try {
      const params = routeQuery || {};

      if (!params.sort && !subMenuOption) {
        params.sort = 'created_at';
      } else if (subMenuOption) {
        params.sort = subMenuOption;
      }

      params.page = page || undefined;

      const result = await getJobProfileTemplates({
        params,
        searchTerm: newSearchTerm,
      });

      jobProfileTemplates.value = result.documents;

      updatePagination(result.pagination);

      updateFilters({
        subMenuOptions: result.sorting,
        searchTerm: result.textFilter,
      });

      if (
        router
        && !isEqual(
          removeEmptyParams(routeStore.route?.query),
          removeEmptyParams(routeQuery),
        )
      ) {
        const newQuery = { ...params };

        if (searchTerm.value) {
          newQuery.q = searchTerm.value;
        }

        router.push({ query: newQuery }).catch(() => true);
      }
    } catch (err) {
      useAppSnackbar().addErrorSnackbar({
        text: `Job Profile templates load error: ${err.message || err}`,
      });

      throw err;
    } finally {
      setLoading({ pageLoading: false, listLoading: false });
    }
  };

  return {
    jobProfileTemplates,
    loadJobProfileTemplates,
  };
});
